/** Reveal the reply target above the floating composer, without scrolling the modal. */
export function scrollReplyIntoView(viewport: HTMLElement, composer: HTMLElement) {
  const target = viewport.querySelector<HTMLElement>('.comment-item.is-reply-target')

  if (!target) return

  const viewportRect = viewport.getBoundingClientRect()
  const targetRect = target.getBoundingClientRect()
  const visibleTop = viewportRect.top + 12
  const visibleBottom = Math.min(viewportRect.bottom, composer.getBoundingClientRect().top) - 12
  const availableHeight = visibleBottom - visibleTop

  if (availableHeight <= 0) return

  // For a long comment, keep the author and beginning visible rather than its end.
  const visibleHeight = Math.min(targetRect.height, availableHeight)

  if (targetRect.top >= visibleTop && targetRect.top + visibleHeight <= visibleBottom) return

  const desiredTop = visibleBottom - visibleHeight

  viewport.scrollTo({
    top: Math.max(0, viewport.scrollTop + targetRect.top - desiredTop),
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
  })
}
